import {
  dateSchema,
  referenceObject,
  requiredString,
  requiredNumber,
} from "components/form/utils";

import { z } from "zod";

export const getMilestoneSchema = (type, status) => {
  const defaults = {
    name: requiredString(),
    coordinator: referenceObject(),
    start_date: dateSchema,
    end_date: dateSchema,
    status: z.enum([
      "in_progress",
      "completed",
      "closed",
      "archived",
    ]),
    description: z.optional(z.string()).nullable(),
  };

  if ((type === "hourly" || type === "bucket") && (status === "closed" || status === "completed")) {
    defaults.billable_hours = requiredNumber("Billable hours is required");
  }

  return z.object(defaults);
};
